import qs from 'qs';

export const exists = (location, parameter) =>
    qs.parse(location.search, {ignoreQueryPrefix: true})[parameter] !== undefined &&
    qs.parse(location.search, {ignoreQueryPrefix: true})[parameter] !== null;

export const parse = (location, parameter) => qs.parse(location.search, {ignoreQueryPrefix: true})[parameter];
